module.exports = __webpack_public_path__ + "static/img/img01.d062e07.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/img01.png
// module id = YEAZ
// module chunks = 1